import { useTranslation } from '@dreamstack/i18n'
import { assertPopulatedDeep } from '@dreamstack/payload/src/lib/assertPopulated'
import { cn } from '@dreamstack/util/src/cn'
import map from 'lodash/map'
import Image from 'next/image'
import Link from 'next/link'
import { forwardRef, type FunctionComponent } from 'react'
import { Text_16_24 } from './Texts'
import { useNavBarEntries } from './useNavBarEntries'

const containerClass =
  'bg-accentroGray-full text-accentroWhite-full z-10 px-4 md:px-12 py-16 md:py-8 flex flex-col md:flex-row items-center justify-center'
const companyLabelClass = 'text-xl font-extrabold tracking-wide'
const spacerClass = 'flex-1'
const linksWrapperClass =
  'flex flex-row flex-wrap -mx-3 -my-1 md:-m-4 items-center justify-center pt-6 md:pt-0'
const linkClass =
  'md:m-4 mx-3 my-1 cursor-pointer border-b-2 border-transparent hover:border-current'

const StyledLink = forwardRef<HTMLAnchorElement, React.ComponentProps<'a'>>(
  ({ className, children, ...rest }, ref) => (
    <a ref={ref} className={cn(linkClass, className)} {...rest}>
      {children}
    </a>
  )
)

StyledLink.displayName = 'StyledLink'

export const Footer: FunctionComponent<
  React.PropsWithChildren<unknown>
> = () => {
  const entries = useNavBarEntries('Footer')
  const t = useTranslation()
  return (
    <>
      <div className={containerClass}>
        <div className={companyLabelClass}>
          <Image
            src={'/static/images/accentro-logo-white.png'}
            width={175}
            height={20}
            alt={'Accentro Logo image'}
          />
        </div>
        <div className={spacerClass} />
        <div className={linksWrapperClass}>
          <StyledLink
            href="#"
            onClick={(e) => {
              e.preventDefault()

              /* @ts-ignore */
              UC_UI.showSecondLayer()
            }}
          >
            <Text_16_24 className="font-semibold">
              {t('accentro:footer.cookies')}
            </Text_16_24>
          </StyledLink>
          {map(entries, (entry) => {
            assertPopulatedDeep(entry)
            const slug = entry.staticPage?.slug
            return (
              <Link key={slug} href={`/${slug}`} passHref legacyBehavior>
                <StyledLink>
                  <Text_16_24 className="font-semibold">{entry.label}</Text_16_24>
                </StyledLink>
              </Link>
            )
          })}
        </div>
      </div>
    </>
  )
}
